import { AlertTriangle } from 'lucide-react';

/**
 * Splash rendered when the customer's license is disabled or
 * expired. Mirrors legacy `wf-audit/src/slices/common/pages/error/license.tsx`
 * but drops the iframe / popup detection — the new SPA is iframe-only,
 * so there's no popup branch.
 *
 * Trigger: `LicenseProvider` detects `isExpired === true` (either a
 * 410 from `/v1/license` or `enabled: false` on the row) and renders
 * this page instead of the normal route tree.
 */
export function LicenseExpiredPage(): JSX.Element {
  return (
    <div className="relative z-10 flex min-h-[calc(100vh-7rem)] items-center justify-center p-6">
      <div className="max-w-md rounded-2xl border border-foreground/15 bg-foreground/[0.03] p-8 text-center">
        <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-foreground/5">
          <AlertTriangle className="h-6 w-6 text-[color:var(--brand-yellow)]" />
        </div>
        <h1 className="mb-2 text-3xl font-light text-foreground">License expired</h1>
        <p className="mb-6 text-sm text-foreground/60">
          The WorkFocus license for your Workfront domain has expired. To obtain an annual license,
          please visit{' '}
          <a
            href="https://workfocus.io"
            className="font-semibold text-[color:var(--brand-yellow)] hover:underline"
            target="_blank"
            rel="noreferrer noopener"
          >
            workfocus.io
          </a>{' '}
          or email{' '}
          <a
            href="mailto:support@workfocus.io"
            className="font-semibold text-[color:var(--brand-yellow)] hover:underline"
          >
            support@workfocus.io
          </a>
          .
        </p>
      </div>
    </div>
  );
}
